module.exports = "mutation BulkDeleteContacts($contacts: [ID!]!) {\n  bulkDeleteContacts(contacts: $contacts) {\n    successful\n    failedCount\n  }\n}\n"